import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

const ArticlesListField = ({ record = {} }) => {
  console.log(record);
  if (!record['articles'] || record['articles'].length === 0) {
    return <span />;
  }

  const items = record['articles'].map(item => (
    <li key={item['url']}>
      <a href={item['url']} target="_blank" title={item['title']} rel="noopener noreferrer">
        {item['title']}
      </a>
    </li>
  ));
  return (
    <div className="articles-list">
      <Button variant="contained" className="button">
        Articles
      </Button>
      <ul>{items}</ul>
    </div>
  );
};

ArticlesListField.propTypes = {
  record: PropTypes.object,
};

export default ArticlesListField;



// WEBPACK FOOTER //
// ./src/resources/ui/ArticlesListField.js